'use client';

import { cn } from '../../../../lib/utils';
import { useColorPickerContext } from './color-picker-context';

const DEFAULT_PRESET_COLORS = [
  '#FFFFFF',
  '#000000',
  '#ECEEF6',
  '#DDE0EB',
  '#BABECF',
  '#7C8299',
  '#565A6A',
  '#393B46',
  '#FFDDDD',
  '#FF9597',
  '#FF4F53',
  '#EF3034',
  '#A30A0C',
  '#FFCD9A',
  '#FFA03E',
  '#FF8100',
  '#E06800',
  '#FFEDB2',
  '#FFD24A',
  '#FFAA00',
  '#D6FFD7',
  '#71F392',
  '#1DD168',
  '#00A352',
  '#00713C',
  '#BFDFFF',
  '#78BBFF',
  '#1981FF',
  '#0852D4',
  '#001F99',
  '#EDE7FF',
  '#C7B4FF',
  '#9570FF',
  '#6431F6',
  '#3709BA',
  '#F11C9F',
];

export interface ColorPickerPresetsProps {
  colors?: string[];
  label?: string;
  className?: string;
}

export function ColorPickerPresets({
  colors = DEFAULT_PRESET_COLORS,
  label = 'Color presets',
  className,
}: ColorPickerPresetsProps) {
  const { onChange, onChangeEnd, setLastSolidColor } = useColorPickerContext();

  return (
    <div className={cn('flex flex-col gap-2xs', className)}>
      <div className="flex items-center gap-2xs">
        <div className="h-px flex-1 bg-sys-style-neutral-light" />
        <span className="shrink-0 text-comp-accent-small font-bold text-sys-cont-neutral-light">
          {label}
        </span>
        <div className="h-px flex-1 bg-sys-style-neutral-light" />
      </div>
      <div className="grid grid-cols-12 gap-2xs">
        {colors.map((color) => {
          const normalized = color.toUpperCase();
          return (
            <button
              key={normalized}
              type="button"
              onClick={() => {
                setLastSolidColor(normalized);
                onChange(normalized);
                onChangeEnd?.(normalized);
              }}
              className="size-[20px] cursor-crosshair rounded-3xs border border-sys-style-neutral-deep transition-transform duration-100 ease-out hover:scale-110"
              style={{ backgroundColor: normalized }}
              aria-label={`Preset ${normalized}`}
            />
          );
        })}
      </div>
    </div>
  );
}
